import NetworkCall from "network/networkCall";
import Request from "network/request";

export default class Workflow {
  static async getEntryPoints() {
    return NetworkCall.fetch(Request.v2.getWorkflowEntryPoints(), false, false);
  }
}
